<block-ui>
  <mat-sidenav-container fullscreen class="Site">
    <mat-sidenav #sidenav disableClose position="end"> <aside-container></aside-container> </mat-sidenav>

    <mat-sidenav-content>
      <main class="main">
        <app-header (toggleMenuEvent)="drawer.toggle()"></app-header>
        <section class="content Site-content">
          <mat-sidenav-container class="nav-container" fullscreen>
            <mat-sidenav #drawer mode="side" [opened]="showMenu" role="navigation" class="side-menu" color="primary">
              <side-menu></side-menu>
            </mat-sidenav>
            <div class="content-main"><router-outlet></router-outlet></div>
          </mat-sidenav-container>
        </section>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</block-ui>
